document.addEventListener("DOMContentLoaded", function () {
  const selectedItemsStep1 = document.getElementById("step1-items");
  const selectedItemsStep2 = document.getElementById("step2-items");
  const selectedItemsStep3 = document.getElementById("step3-items");
  const finalUrlDiv = document.querySelector(".final-url");
  
  const progressBar = document.querySelector(".progress-bar");
  const progressLabel = document.querySelector(".progress-label");
  const goalPrice = 350; // Hedef fiyat
  let selectedProducts = []; // Seçilen ürünlerin bilgileri

  async function selectProduct(stepItems, productHandle, isVariant, variantIdOverride) {
    let selectedVariantId = null;

    if (isVariant) {
      if (variantIdOverride) {
        selectedVariantId = variantIdOverride;
      } else {
        const variantSelector = document.querySelector(
          `.variant-selector[data-handle='${productHandle}']`
        );
        selectedVariantId = variantSelector ? variantSelector.value : null;
      }
    }

    try {
      const productData = await fetchProduct(productHandle);
      if (!productData || !productData.variants || productData.variants.length === 0) {
        console.error("Ürün verisi alınamadı veya varyant bulunamadı:", productHandle);
        return;
      }

      let variantData = null;
      if (isVariant) {
        if (selectedVariantId) {
          variantData = productData.variants.find(
            (variant) => variant.id === parseInt(selectedVariantId)
          );
        }
        // Eğer variant bulunamazsa ilk varyantı al
        if (!variantData && productData.variants.length > 0) {
          variantData = productData.variants[0];
        }
      } else {
        variantData = productData.variants[0];
      }

      if (!variantData) {
        console.error("Varyant bulunamadı:", productHandle, isVariant, selectedVariantId);
        return;
      }

      const customTextInput = document.getElementById(
        `${productHandle}-urun-uzerindeki-yazi`
      );
      const customLetterInput = document.getElementById(
        `${productHandle}-urun-uzerindeki-harf`
      );

      const customText = customTextInput ? customTextInput.value.trim() : "";
      const customLetter = customLetterInput ? customLetterInput.value.trim() : "";

      const listItem = createListItem(
        productData.title,
        productData.image,
        variantData.price,
        variantData.id,
        customText,
        customLetter
      );
      stepItems.appendChild(listItem);

      const existingProduct = selectedProducts.find(
        (product) => product.id === variantData.id
      );

      if (existingProduct) {
        existingProduct.quantity += 1;
      } else {
        selectedProducts.push({
          id: variantData.id,
          title: productData.title,
          image: productData.image,
          price: variantData.price,
          customText: customText,
          customLetter: customLetter,
          quantity: 1,
        });
      }

      updateFinalUrl();
      updateTotalPriceAndProgress();

      // Input'ları temizle (varsa)
      if (customTextInput) {
        customTextInput.value = "";
      }
      if (customLetterInput) {
        customLetterInput.value = "";
      }
    } catch (error) {
      console.error("Error fetching product:", error);
    }
  }

  function updateFinalUrl() {
    finalUrlDiv.innerHTML = "";
    selectedProducts.forEach((product) => {
      let finalUrl = `add?id=${product.id}&quantity=${product.quantity}`;
      if (product.customText)
        finalUrl += `&properties[Ürün üzerindeki yazı]=${encodeURIComponent(
          product.customText
        )}`;
      if (product.customLetter)
        finalUrl += `&properties[Ürün üzerindeki harf]=${encodeURIComponent(
          product.customLetter
        )}`;

      const productUrlElement = document.createElement("div");
      productUrlElement.textContent = finalUrl;
      finalUrlDiv.appendChild(productUrlElement);
    });
  }

  function updateProductQuantity(productId, newQuantity) {
    const product = selectedProducts.find((item) => item.id === productId);
    if (product) {
      product.quantity = newQuantity > 0 ? newQuantity : 1; // Min 1
      updateFinalUrl();
      updateTotalPriceAndProgress();
    }
  }

  function updateTotalPriceAndProgress() {
    const totalPrice = selectedProducts.reduce(
      (sum, product) => sum + product.price * product.quantity,
      0
    );

    // Tüm .total-price elementlerini seç
    const totalPriceElements = document.querySelectorAll(".total-price");

    // Her bir .total-price elementini güncelle
    totalPriceElements.forEach((element) => {
        element.textContent = `Toplam Fiyat: ${totalPrice.toFixed(2)} TL`;
    });


    // İlerleme çubuğunu güncelle
    const progress = Math.min((totalPrice / goalPrice) * 100, 100);
    progressBar.style.width = `${progress}%`;

    // Hedefe kalan miktarı güncelle
    const remaining = Math.max(goalPrice - totalPrice, 0);
    progressLabel.textContent = remaining > 0
      ? `Ücretsiz kargo için kalan: ${remaining.toFixed(2)} TL`
      : "Kargo Bedava! 🎉";
  }

  function createListItem(
    productTitle,
    productImage,
    productPrice,
    variantId,
    customText,
    customLetter
  ) {
    const listItem = document.createElement("li");

    listItem.innerHTML = `
      <div class="line-item">
      <div class="imgae-side">
      <img src="${productImage}" alt="${productTitle}" class="product-image" style="width: 50px; height: 50px; margin-right: 10px;" />
      </div>
      <div class="details">
      <div class="urun-adi"><span class="eklenen-urun">${productTitle}</span></div>
      <div class="urun-fiyat-mikatar-cop">
      <span class="product-each-price">${productPrice} TL</span>
      <div class="miktar-ayar">
      <button class="decrease-quantity">-</button>
      <input type="number" class="product-quantity" value="1" min="1" />
      <button class="increase-quantity">+</button>
      </div>
      <button class="remove-item"><svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" fill="#000000" height="800px" width="800px" version="1.1" id="Capa_1" viewBox="0 0 60.167 60.167" xml:space="preserve">
<path d="M54.5,11.667H39.88V3.91c0-2.156-1.754-3.91-3.91-3.91H24.196c-2.156,0-3.91,1.754-3.91,3.91v7.756H5.667  c-0.552,0-1,0.448-1,1s0.448,1,1,1h2.042v40.5c0,3.309,2.691,6,6,6h32.75c3.309,0,6-2.691,6-6v-40.5H54.5c0.552,0,1-0.448,1-1  S55.052,11.667,54.5,11.667z M22.286,3.91c0-1.053,0.857-1.91,1.91-1.91H35.97c1.053,0,1.91,0.857,1.91,1.91v7.756H22.286V3.91z   M50.458,54.167c0,2.206-1.794,4-4,4h-32.75c-2.206,0-4-1.794-4-4v-40.5h40.75V54.167z M38.255,46.153V22.847c0-0.552,0.448-1,1-1  s1,0.448,1,1v23.306c0,0.552-0.448,1-1,1S38.255,46.706,38.255,46.153z M29.083,46.153V22.847c0-0.552,0.448-1,1-1s1,0.448,1,1  v23.306c0,0.552-0.448,1-1,1S29.083,46.706,29.083,46.153z M19.911,46.153V22.847c0-0.552,0.448-1,1-1s1,0.448,1,1v23.306  c0,0.552-0.448,1-1,1S19.911,46.706,19.911,46.153z"/>
</svg></button>
      </div>
      </div>
    `;

    listItem.querySelector(".increase-quantity").addEventListener("click", () => {
      const quantityInput = listItem.querySelector(".product-quantity");
      quantityInput.value = parseInt(quantityInput.value) + 1;
      updateProductQuantity(variantId, parseInt(quantityInput.value));
    });

    listItem.querySelector(".decrease-quantity").addEventListener("click", () => {
      const quantityInput = listItem.querySelector(".product-quantity");
      quantityInput.value = Math.max(1, parseInt(quantityInput.value) - 1);
      updateProductQuantity(variantId, parseInt(quantityInput.value));
    });

    listItem.querySelector(".product-quantity").addEventListener("input", (e) => {
      updateProductQuantity(variantId, parseInt(e.target.value));
    });

    listItem.querySelector(".remove-item").addEventListener("click", function () {
      listItem.remove();
      selectedProducts = selectedProducts.filter((product) => product.id !== variantId);
      updateFinalUrl();
      updateTotalPriceAndProgress();
    });

    return listItem;
  }

  function fetchProduct(productHandle) {
    return fetch(`/products/${productHandle}.json`)
      .then((response) => response.json())
      .then((data) => ({
        title: data.product.title,
        variants: data.product.variants,
        image: data.product.images[0]?.src || "", // İlk resmi al
      }));
  }

  // Event delegation so dynamically added items also work
  document.addEventListener("click", function (event) {
    const targetButton = event.target.closest(
      ".select-product-step-1, .select-product-step-2, .select-product-step-3"
    );
    if (!targetButton || targetButton.disabled) return;

    const productHandle = targetButton.getAttribute("data-handle");
    if (!productHandle) return;

    const isVariant = targetButton.getAttribute("data-is-variant") === "true";

    // Try to scope variant selection within the clicked product area
    const container = targetButton.closest(
      ".detailed-view, .details, .product-list-item"
    );
    const variantSelector = container
      ? container.querySelector(`.variant-selector[data-handle='${productHandle}']`)
      : null;
    const variantIdOverride = variantSelector ? variantSelector.value : null;

    // If not found in container and isVariant, try document-wide
    let finalVariantId = variantIdOverride;
    if (!finalVariantId && isVariant) {
      const docSelector = document.querySelector(`.variant-selector[data-handle='${productHandle}']`);
      if (docSelector) {
        finalVariantId = docSelector.value;
      }
    }

    if (targetButton.classList.contains("select-product-step-1")) {
      if (selectedItemsStep1) {
        selectProduct(selectedItemsStep1, productHandle, isVariant, finalVariantId);
      }
      return;
    }

    if (targetButton.classList.contains("select-product-step-2")) {
      if (selectedItemsStep2) {
        selectProduct(selectedItemsStep2, productHandle, isVariant, finalVariantId);
      }
      return;
    }

    if (targetButton.classList.contains("select-product-step-3")) {
      if (selectedItemsStep3) {
        selectProduct(selectedItemsStep3, productHandle, isVariant, finalVariantId);
      }
    }
  });




  const addToCartBtn = document.getElementById("add-to-cart");
  if (addToCartBtn) {
    addToCartBtn.addEventListener("click", function () {
  if (selectedProducts.length === 0) {
    alert("Sepete eklemek için ürün seçmelisiniz.");
    return;
  }

  const cartItems = selectedProducts.map((product) => ({
    id: product.id,
    quantity: product.quantity,
    properties: {
      "Ürün üzerindeki yazı": product.customText || "",
      "Ürün üzerindeki harf": product.customLetter || "",
    },
  }));

  fetch("/cart/add.js", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify({ items: cartItems }),
  })
    .then((response) => {
      if (!response.ok) throw new Error("Failed to add items to cart");
      return response.json();
    })
    .then(() => {
      window.location.href = "/cart";
    })
    .catch((error) => {
      console.error("Error adding items to cart:", error);
      alert("Hata: Ürün sepete eklenemedi.");
    });
  });
  }
  /**/
  const selectCartBtn = document.getElementById("select-cart");
  if (selectCartBtn) {
    selectCartBtn.addEventListener("click", function () {
  if (selectedProducts.length === 0) {
    alert("Sepete eklemek için ürün seçmelisiniz.");
    return;
  }

  const cartItems = selectedProducts.map((product) => ({
    id: product.id,
    quantity: product.quantity,
    properties: {
      "Ürün üzerindeki yazı": product.customText || "",
      "Ürün üzerindeki harf": product.customLetter || "",
    },
  }));

  fetch("/cart/add.js", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify({ items: cartItems }),
  })
    .then((response) => {
      if (!response.ok) throw new Error("Failed to add items to cart");
      return response.json();
    })
    .then(() => {
      // Sepete ekleme başarılı olduğunda yönlendirme
      window.location.href = "https://trendmiya.com/collections/mesaj-kartlari";
    })
    .catch((error) => {
      console.error("Error adding items to cart:", error);
      alert("Hata: Ürün sepete eklenemedi.");
    });
});
  }
});


